import {
  ConsultaSeguimentoPergunta05ExemplosEnum,
  ConsultaSeguimentoPergunta05Model,
} from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/perguntas/consulta-seguimento-pergunta-05/model-consultaSeguimentoPergunta05'
import { MchatRfAplicacaoQueryModel } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/model-mChatRf'
import { booleanToSimNaoEnum } from 'components/form'
import { MChatPerguntaEnum } from 'graphql/types.generated'

import { HISTORICO_MCHAT_CALCULATION_STATUS } from '../utils-HistoricoMchatRf'

interface HistoricoMChatRfPergunta05Model {
  header: MchatRfAplicacaoQueryModel
  exemplosPassou: MchatRfAplicacaoQueryModel[]
  exemplosFalhou: MchatRfAplicacaoQueryModel[]
  perguntaFrequencia: MchatRfAplicacaoQueryModel | undefined
  model: ConsultaSeguimentoPergunta05Model
}

export const convertAplicacaoPergunta05 = (
  aplicacoes: ReadonlyArray<MchatRfAplicacaoQueryModel>
): HistoricoMChatRfPergunta05Model | null => {
  const header = aplicacoes.find((aplicacao) => aplicacao.pergunta === MChatPerguntaEnum.PERGUNTA_05_01)
  const exemplosPassou = aplicacoes.filter((aplicacao) => PERGUNTA_05_EXEMPLOS_PASSOU.includes(aplicacao.pergunta))
  const exemplosFalhou = aplicacoes.filter((aplicacao) => PERGUNTA_05_EXEMPLOS_FALHOU.includes(aplicacao.pergunta))
  const perguntaFrequencia = aplicacoes.find((aplicacao) => aplicacao.pergunta === MChatPerguntaEnum.PERGUNTA_05_09)

  if (header == undefined) return null

  return {
    header,
    exemplosPassou,
    exemplosFalhou,
    perguntaFrequencia,
    model: {
      status: HISTORICO_MCHAT_CALCULATION_STATUS,
      PERGUNTA_05_HEADER: booleanToSimNaoEnum(header.stPassou),
      PERGUNTA_05_EXEMPLOS: {
        PASSOU: convertAplicacoesToExemplos(exemplosPassou),
        FALHOU: convertAplicacoesToExemplos(exemplosFalhou),
      },
      PERGUNTA_05_DUAS_VEZES_POR_SEMANA: booleanToSimNaoEnum(perguntaFrequencia?.stPassou),
      OUTRO: convertAplicacaoToOutro(
        exemplosFalhou.find((aplicacao) => aplicacao.pergunta === MChatPerguntaEnum.PERGUNTA_05_08)
      ),
    },
  }
}

const convertAplicacoesToExemplos = (
  aplicacoes: ReadonlyArray<MchatRfAplicacaoQueryModel>
): Record<ConsultaSeguimentoPergunta05ExemplosEnum, ReturnType<typeof booleanToSimNaoEnum>> =>
  aplicacoes.reduce<Record<ConsultaSeguimentoPergunta05ExemplosEnum, ReturnType<typeof booleanToSimNaoEnum>>>(
    (acc, aplicacao) => {
      const pergunta = MAP_PERGUNTA_TO_ENUM[aplicacao.pergunta]

      if (pergunta) {
        acc[pergunta] = booleanToSimNaoEnum(aplicacao.stPassou)
      }

      return acc
    },
    { ...EMPTY_EXEMPLOS }
  )

const convertAplicacaoToOutro = (
  aplicacao: MchatRfAplicacaoQueryModel | undefined
): ConsultaSeguimentoPergunta05Model['OUTRO'] => ({
  radioValue: booleanToSimNaoEnum(aplicacao?.stPassou),
  textValue: aplicacao?.outros ?? undefined,
})

const PERGUNTA_05_EXEMPLOS_PASSOU = [MChatPerguntaEnum.PERGUNTA_05_02, MChatPerguntaEnum.PERGUNTA_05_03]

const PERGUNTA_05_EXEMPLOS_FALHOU = [
  MChatPerguntaEnum.PERGUNTA_05_04,
  MChatPerguntaEnum.PERGUNTA_05_05,
  MChatPerguntaEnum.PERGUNTA_05_06,
  MChatPerguntaEnum.PERGUNTA_05_07,
  MChatPerguntaEnum.PERGUNTA_05_08,
]

const EMPTY_EXEMPLOS: Record<ConsultaSeguimentoPergunta05ExemplosEnum, undefined> = {
  [ConsultaSeguimentoPergunta05ExemplosEnum.OLHA_PARA_AS_MAOS]: undefined,
  [ConsultaSeguimentoPergunta05ExemplosEnum.MOVE_OS_DEDOS_QUANDO_BRINCA_DE_ESCONDER_ROSTO]: undefined,
  [ConsultaSeguimentoPergunta05ExemplosEnum.MOVIMENTA_OS_DEDOS_PERTO_DOS_OLHOS]: undefined,
  [ConsultaSeguimentoPergunta05ExemplosEnum.MANTEM_AS_MAOS_ELEVADAS_PERTO_DOS_OLHOS]: undefined,
  [ConsultaSeguimentoPergunta05ExemplosEnum.MANTEM_AS_MAOS_AO_LADO_DOS_OLHOS]: undefined,
  [ConsultaSeguimentoPergunta05ExemplosEnum.AGITA_AS_MAOS_PERTO_DO_ROSTO]: undefined,
}

const MAP_PERGUNTA_TO_ENUM: Partial<Record<MChatPerguntaEnum, ConsultaSeguimentoPergunta05ExemplosEnum>> = {
  [MChatPerguntaEnum.PERGUNTA_05_02]: ConsultaSeguimentoPergunta05ExemplosEnum.OLHA_PARA_AS_MAOS,
  [MChatPerguntaEnum.PERGUNTA_05_03]:
    ConsultaSeguimentoPergunta05ExemplosEnum.MOVE_OS_DEDOS_QUANDO_BRINCA_DE_ESCONDER_ROSTO,
  [MChatPerguntaEnum.PERGUNTA_05_04]: ConsultaSeguimentoPergunta05ExemplosEnum.MOVIMENTA_OS_DEDOS_PERTO_DOS_OLHOS,
  [MChatPerguntaEnum.PERGUNTA_05_05]: ConsultaSeguimentoPergunta05ExemplosEnum.MANTEM_AS_MAOS_ELEVADAS_PERTO_DOS_OLHOS,
  [MChatPerguntaEnum.PERGUNTA_05_06]: ConsultaSeguimentoPergunta05ExemplosEnum.MANTEM_AS_MAOS_AO_LADO_DOS_OLHOS,
  [MChatPerguntaEnum.PERGUNTA_05_07]: ConsultaSeguimentoPergunta05ExemplosEnum.AGITA_AS_MAOS_PERTO_DO_ROSTO,
}
